import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Player,
  ControlBar,
  BigPlayButton,
  LoadingSpinner,
  ReplayControl,
  ForwardControl,
  PlaybackRateMenuButton
} from 'video-react';
import poster from '../assets/videoThumbnailRectangle.jpg';


export default class VideoPlayer extends Component {
  constructor(props, context) {
    super(props, context);

    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.load = this.load.bind(this);
    this.changeCurrentTime = this.changeCurrentTime.bind(this);
    this.seek = this.seek.bind(this);
    this.changePlaybackRateRate = this.changePlaybackRateRate.bind(this);
    this.changeVolume = this.changeVolume.bind(this);
    this.setMuted = this.setMuted.bind(this);
  }
  componentDidMount() {
    // subscribe state change
    this.player.subscribeToStateChange(this.handleStateChange.bind(this));
  }

  componentDidUpdate(){
    const platform = window.navigator.platform;
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    const { player } = this.player.getState();
    if (iosPlatforms.indexOf(platform) !== -1){
     //do nothing
    }
    else if(( window.innerWidth <= 800 ) && ( window.innerHeight <= 600 ) && player.isFullscreen){
      screen.orientation.lock('landscape');
    }
  }

  setMuted(muted) {
    return () => {
      this.player.muted = muted;
    };
  }

  handleStateChange(state) {
    // copy player state to this component's state
    this.setState({
      player: state
    });
  }

  play() {
    this.player.play();
  }

  pause() {
    this.player.pause();
  }

  load() {
    this.player.load();
  }

  changeCurrentTime(seconds) {
    return () => {
      const { player } = this.player.getState();
      this.player.seek(player.currentTime + seconds);
    };
  }

  seek(seconds) {
    return () => {
      this.player.seek(seconds);
    };
  }

  changePlaybackRateRate(steps) {
    return () => {
      const { player } = this.player.getState();
      this.player.playbackRate = player.playbackRate + steps;
    };
  }

  changeVolume(steps) {
    return () => {
      const { player } = this.player.getState();
      this.player.volume = player.volume + steps;
    };
  }

  changeSource() {
    return () => {
      this.setState({
        source: this.props.src
      });
      this.player.load();
    };
  }

  render() {
    return (
      <Player
        fluid={false}
        width="100%"
        className="player"
        ref={player => {
          this.player = player;
        }}
        autoPlay={this.props.autoPlay}
        poster={this.props.poster || poster}
        key={this.props.source}
      >
        <source src={this.props.source} />
        <ControlBar autoHide={true}>
          <ReplayControl seconds={10} order={1} />
          <ForwardControl seconds={10} order={3} />
          <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={5} />
        </ControlBar>
        <BigPlayButton position="center" />
        <LoadingSpinner />
      </Player>
    );
  }
}

VideoPlayer.propTypes = {
  autoPlay: PropTypes.bool,
  poster: PropTypes.string,
  source: PropTypes.string,
  src: PropTypes.string
};
